// extracted by mini-css-extract-plugin
export default {"Header":"StteperHeader_Header__qUtbG","Title":"StteperHeader_Title__yQNy5"};